document.querySelectorAll('[data-qtp]').forEach((root) => {
  const tabs = [...root.querySelectorAll('[data-qtp-layer-tab]')];
  const panels = [...root.querySelectorAll('[data-qtp-layer-panel]')];

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach((item, itemIndex) => {
        const active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
      });
      panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    });
  });
});
